/*
* Palo Alto Theme
*/

(function() {
  // Add custom code below this line

  function patchProto() {
    var cartEl = document.querySelector('cart-element');
    if (!cartEl) return;

    var proto = Object.getPrototypeOf(cartEl);
    if (!proto || !proto.freeShippingMessageHandle || proto._tieredPatched) return;

    var origFreeShipping = proto.freeShippingMessageHandle;
    proto.freeShippingMessageHandle = function(subtotal) {
      origFreeShipping.call(this, subtotal);
      runTieredBar(subtotal);
    };

    var origUpdateProgress = proto.updateProgress;
    proto.updateProgress = function() {
      origUpdateProgress.call(this);
      runTieredBar(this.subtotal);
    };

    proto._tieredPatched = true;
  }

  function runTieredBar(cartTotal) {
    var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) ? parseFloat(window.Shopify.currency.rate) : 1;

    document.querySelectorAll('[data-cart-message][data-limit-2]').forEach(function(el) {
      var limit1 = parseFloat(el.getAttribute('data-limit')) * 100 * rate;
      var limit2 = parseFloat(el.getAttribute('data-limit-2')) * 100 * rate;
      var limit3 = parseFloat(el.getAttribute('data-limit-3')) * 100 * rate;
      var msg1 = el.getAttribute('data-message-1');
      var msg2 = el.getAttribute('data-message-2');
      var msg3 = el.getAttribute('data-message-3');

      if (!limit1 || !limit2 || !limit3) return;

      if (cartTotal === undefined || cartTotal === null) {
        var cartTotalEl = document.querySelector('[data-cart-total]');
        cartTotal = cartTotalEl ? parseFloat(cartTotalEl.getAttribute('data-cart-total')) : 0;
      }

      if (cartTotal === 0) {
        el.classList.add('is-hidden');
        return;
      }

      var activeMsg, percent, activeLimit;

      if (cartTotal < limit1) {
        activeMsg = msg1;
        activeLimit = limit1;
        percent = (cartTotal / limit1) * 100;
      } else if (cartTotal < limit2) {
        activeMsg = msg2;
        activeLimit = limit2;
        percent = ((cartTotal - limit1) / (limit2 - limit1)) * 100;
      } else if (cartTotal < limit3) {
        activeMsg = msg3;
        activeLimit = limit3;
        percent = ((cartTotal - limit2) / (limit3 - limit2)) * 100;
      } else {
        activeMsg = msg3;
        activeLimit = limit3;
        percent = 100;
      }

      percent = Math.min(Math.max(percent, 0), 100);
      var isSuccess = cartTotal >= limit3;

      el.classList.remove('is-hidden');
      el.classList.toggle('is-success', isSuccess);

      var successSpan = el.querySelector('.cart-message__success');
      if (successSpan) {
        successSpan.style.display = isSuccess ? '' : 'none';
      }

      el.querySelectorAll('[data-cart-message-progress]').forEach(function(bar, i) {
        bar.style.setProperty('--progress-width', percent + '%');
        if (i === 0) bar.setAttribute('value', percent);
        bar.classList.remove('is-hidden');
      });

      var leftToSpendEl = el.querySelector('[data-left-to-spend]');
      var messageDefaultEl = el.querySelector('[data-message-default]');

      if (leftToSpendEl && messageDefaultEl && activeMsg) {
        var remaining = Math.max(activeLimit - cartTotal, 0);
        var formatted;
        if (window.theme.settings && window.theme.settings.currency_code_enable) {
          formatted = window.theme.formatMoney(remaining, window.theme.moneyWithCurrencyFormat || window.theme.moneyFormat);
        } else {
          formatted = window.theme.formatMoney(remaining, window.theme.moneyFormat);
        }
        leftToSpendEl.innerHTML = formatted;
        messageDefaultEl.innerHTML = activeMsg.replace('||amount||', leftToSpendEl.outerHTML);
        messageDefaultEl.classList.remove('is-hidden');
        messageDefaultEl.style.display = isSuccess ? 'none' : '';
      }
    });
  }

  customElements.whenDefined('cart-element').then(function() {
    patchProto();
  });

  document.addEventListener('theme:cart:loaded', function() {
    patchProto();
    setTimeout(function() { runTieredBar(); }, 100);
  });

  document.addEventListener('theme:cart:added', function() {
    setTimeout(function() { runTieredBar(); }, 100);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();